'use client';
import { jsx } from 'react/jsx-runtime';
import { DialogRoot } from '../dialog/dialog-root.mjs';
import { DrawerContextProvider } from './drawer-context.mjs';
import { getDrawerPlacement } from './get-placement.mjs';
import { useTheme } from '../system/use-theme.mjs';

function DrawerRoot(props) {
  const {
    isOpen,
    onClose,
    placement: placementProp = "right",
    children,
    ...rest
  } = props;
  const theme = useTheme();
  const drawerStyleConfig = theme.components?.Drawer;
  const placement = getDrawerPlacement(placementProp, theme.direction);
  return /* @__PURE__ */ jsx(DrawerContextProvider, { value: { placement }, children: /* @__PURE__ */ jsx(
    DialogRoot,
    {
      isOpen,
      onClose,
      styleConfig: drawerStyleConfig,
      ...rest,
      children
    }
  ) });
}

export { DrawerRoot };
